{
  "staging": {
    "apiUrl": "https://api.s.tellent.com",
    "baseUrl": "https://updates.s.tellent.com"
  },
  "rc": {
    "apiUrl": "https://api.rc.tellent.com",
    "baseUrl": "https://updates.rc.tellent.com"
  },
  "production": {
    "apiUrl": "https://api.tellent.com",
    "baseUrl": "https://updates.tellent.com"
  }
}
